import React, {Component} from 'react';

import ReferenceStarsRating from './reference_stars_rating';
import StarsRatingField from './stars_rating_field';
import CollapsableText from './collapsable_text';
import {ReferencePopulationRatingTypes} from '../constants.js.erb';

export default class ReferencesSummary extends Component {
  constructor(props) {
    super(props);
    let {trial, reference_population_ids, checkMatching, show_details} = props;
    let scored_populations = trial.reference_populations_data.filter(p => p.data !== null && !p.only_info);
    this.state = {scored_populations, show_references: show_details};

    if (checkMatching) {
      let {matched_populations, unmatched_populations} = classifyReferencePopulations(scored_populations, reference_population_ids);
      this.state.matched_populations = matched_populations;
      this.state.unmatched_populations = unmatched_populations;
    } else {
      this.state.unmatched_populations = scored_populations;
    }
  }

  toggleReferencesVisibility() {
    let show_references = !this.state.show_references;
    this.setState({show_references})
  }

  renderMatchedPopulationsRating() {
    let {checkMatching} = this.props;
    if (!checkMatching) return null;


    let {matched_populations} = this.state;
    let efficacy_ceiling = matched_populations.reduce(efficacyCeiling, null);
    return (
      <div className="ref_summary_box">
        <div className="ref_summary_header">
          <span className="ref_pop_label match_label">{matched_populations.length} Matched</span>
          Highest Efficacy:
        </div>
        <StarsRatingField value={efficacy_ceiling} starsCount={5} extraOptions={ReferenceStarsRating.EXTRA_OPTIONS} valueComponentOnly={true}/>
      </div>
    )
  }

  renderUnmatchedPopulationsRating() {
    let {checkMatching} = this.props;
    let {unmatched_populations} = this.state;
    let unmatched_efficacy_ceiling = unmatched_populations.reduce(efficacyCeiling, null);
    let label = checkMatching ? 'Related' : 'Populations';
    return (
      <div className="ref_summary_box">
        <div className="ref_summary_header">
          <span className="ref_pop_label related_label">{unmatched_populations.length} {label}</span>
          Highest Efficacy:
        </div>
        <StarsRatingField value={unmatched_efficacy_ceiling} starsCount={5} extraOptions={ReferenceStarsRating.EXTRA_OPTIONS} valueComponentOnly={true}/>
      </div>
    )
  }

  renderReferencesSummary() {
    let {scored_populations, show_references} = this.state;
    let wrapperClass = "reference_rating_wrapper";
    let show_button;
    if (scored_populations.length > 0) {
      let show_button_label = show_references ? 'Hide' : 'Show';
      show_button = <a className="ref_see_more_button" onClick={e => this.toggleReferencesVisibility()}>{show_button_label} Details</a>
    } else {
      wrapperClass += " no_references";
    }

    let details_open_class = show_references ? 'references_rating_summary ref_details_open' : 'references_rating_summary';
    let side_effect_floor = scored_populations.reduce(sideEffectFloor, null);

    return (
      <div className={wrapperClass}>
        <div className={details_open_class}>
          {this.renderMatchedPopulationsRating()}
          {this.renderUnmatchedPopulationsRating()}
          <div className="ref_summary_box">
            <div className="ref_summary_header">
              <span>Lowest Safety:</span>
            </div>
              <StarsRatingField value={side_effect_floor} starsCount={5} extraOptions={ReferenceStarsRating.EXTRA_OPTIONS} valueComponentOnly={true}/>
          </div>
        </div>
        {show_button}
      </div>
    );
  }

  renderReferencesContent() {
    let {trial, reference_population_ids} = this.props;
    let changelog;

    if (trial.trial_references_changelog.length > 0) {
      let last = trial.trial_references_changelog[trial.trial_references_changelog.length -1]
      let date = moment(last.date).format('LLL')
      changelog = <p className="changelog-item">On {date}  checked for references and found no updates.</p>
    }

    return (
      <div className="search_reference_display">
        <div>
          <TrialReferences trial={trial} reference_population_ids={reference_population_ids} />
        </div>
        {changelog}
      </div>
    )
  }


  renderReferences() {
    let {show_references} = this.state;
    if (!show_references) return null;
    let {trial} = this.props;

    return (
      <div className="references_dropdown">
        <h4>References</h4>
        {this.renderReferencesContent(trial)}
        <button onClick={e => this.setState({show_references: false})} className="pull-right btn btn-sm btn-warning">Close</button>
        <div className="clearfix"></div>
      </div>
    );
  }


  render() {
    return (
      <div>
        {this.renderReferencesSummary()}
        {this.renderReferences()}

      </div>
    );
  }
}


class TrialReferences extends Component {
  constructor(props) {
    super(props);

    // Denormalize data
    let {trial, reference_population_ids} = props;
    let records = trial.references.map(reference => {
      let populations = trial.reference_populations_data.filter(p => p.reference_id === reference.id);
      return {reference, populations};
    });

    records = records.sort(compareReferenceRecords);
    this.state = {records};
  }

  renderDetails(population) {
    if (!population.data) return null;
    if (population.data.ratings && population.data.ratings.length > 0) return this.renderRatings(population);
    if (population.data.notable_information && population.data.notable_information.length > 0) return this.renderNotableInformation(population);
    return null;
  }

  renderNotableInformation(population) {
    return <p>{population.data.notable_information}</p>;
  }

  renderRatings(population) {
    if (!population.data || !population.data.ratings || population.data.ratings.length === 0) return null;
    let ratings = population.data.ratings;

    return (
      <div>
        <div className="reference_population_rating">
          <div className="rating_type"></div>
          <div className="rating_stars"><b>Efficacy</b></div>
          <div className="rating_stars"><b>Safety</b></div>

        </div>
        {ratings.map((rating, index) => {
          let rating_type = ReferencePopulationRatingTypes[rating.rating_type];
          let item_names = rating.items.map(i => i.name).join(', ');
          return (
            <div key={index} className="reference_population_rating">
              <div className="rating_type">
                <strong>{rating_type}</strong><br/>
                <span className="rating_items">{item_names}</span>
              </div>
              <div className="rating_stars">
                <StarsRatingField value={rating.efficacy_rating} starsCount={5} extraOptions={ReferenceStarsRating.EXTRA_OPTIONS} valueComponentOnly={true}/>
                <CollapsableText className="rating_description_text">{rating.efficacy_description}</CollapsableText>
              </div>
              <div className="rating_stars">
                <StarsRatingField value={rating.safety_rating} starsCount={5} extraOptions={ReferenceStarsRating.EXTRA_OPTIONS} valueComponentOnly={true}/>
                <CollapsableText className="rating_description_text">{rating.safety_description}</CollapsableText>
              </div>
            </div>
          )
        })}
      </div>
    )
  }


  renderAIDetails(population) {
    if (!population.ai) return null;
    return <p className="data_source">Source {population.data_source}</p>
  }

  renderReferencePopulation(population, reference) {
    let {reference_population_ids} = this.props;
    let title,  match_el, match_type_class, only_info_el, ai_el;

    if (population.match_cancer_type) {
      match_el = <span className="ref_pop_label match_label">Match</span>;
      match_type_class = "reference_population_rating_container matching_pop";
    } else if (!reference_population_ids) {
      match_el = <span className="ref_pop_label ai_prediction_label">Scored Population</span>;
      match_type_class = "reference_population_rating_container";
    } else {
      match_el = <span className="ref_pop_label related_label">Related</span>;
      match_type_class = "reference_population_rating_container related_pop";
    }

    if (population.only_info) {
      only_info_el = <span className="ref_pop_label info_only_label" >Info Only</span>;
    }

    if (population.ai) {
      ai_el = <span className="ref_ai_label">AI</span>
      title = population.name;
    } else {
      let link = `/admin/trials/${population.trial_id}/populations/${population.id}`;
      title = <a href={link} target="_blank">{population.name}</a>
    }

    let key = reference.id + '::' + population.id;
    return (
      <div key={key} className={match_type_class}>
        <div className="ref_pop_header">
          {ai_el} {match_el} {only_info_el}
          <strong>{title}</strong>
        </div>
        {this.renderDetails(population)}
        {this.renderAIDetails(population)}
      </div>
    )
  }


  renderAISignificantFinding(reference) {
    if (!reference.workflow_data || !reference.workflow_data.triage_data) return null;
    let {significant_finding} = reference.workflow_data.triage_data;
    if (!significant_finding || significant_finding.length === 0) return null;
    return (
      <p className="ai_significant_finding">{significant_finding}</p>
    )
  }

  renderReference(reference, populations) {
    let link = `/admin/references/${reference.id}`;
    let link_text = reference.source_link
    if (link_text && link_text.length > 60) {
      link_text = link_text.substring(0, 60) + '...';
    }

    return (
      <div key={reference.id} className="reference_rating">
        <div className="reference_rating_header">
          <h5><a href={link} target="_blank">{reference.name} ({reference.reference_year})</a></h5>
          {this.renderAISignificantFinding(reference)}
          <a href={reference.source_link} target="_blank">{link_text}</a>
        </div>
        {populations.map(p => this.renderReferencePopulation(p, reference))}
        <hr />
      </div>
    );
  }



  render() {
    let {records} = this.state;

    return (
      <div>
        {records.map(({reference, populations}) => this.renderReference(reference, populations))}
      </div>
    )
  }
}


function efficacyCeiling(acc, population) {
  if (!population.data || !population.data.ratings) return acc;

  for (let ratings of population.data.ratings) {
    if (ratings.efficacy_rating && (acc === null || ratings.efficacy_rating > acc)) {
      acc = ratings.efficacy_rating;
    }
  }
  return acc;
}

function sideEffectFloor(acc, population) {
  if (!population.data || !population.data.ratings) return acc;

  for (let ratings of population.data.ratings) {
    if (ratings.safety_rating && ratings.safety_rating >= 0 && (acc === null || ratings.safety_rating < acc)) {
      acc = ratings.safety_rating;
    }
  }
  return acc;
}


function compareReferenceRecords(record_a, record_b) {
  let reference_a = record_a.reference;
  let populations_a = record_a.populations;
  let reference_a_has_matching_populations = populations_a.some(p => p.match_cancer_type);

  let reference_b = record_b.reference;
  let populations_b = record_b.populations;
  let reference_b_has_matching_populations = populations_b.some(p => p.match_cancer_type);

  if (reference_a_has_matching_populations && !reference_b_has_matching_populations) {
    return -1;
  }

  if (!reference_a_has_matching_populations && reference_b_has_matching_populations) {
    return 1;
  }

  if (populations_a.length > populations_b.length) {
    return -1;
  }

  if (populations_a.length < populations_b.length) {
      return 1;
  }

  if (reference_a.reference_year === reference_b.reference_year) {
    return 0;
  }

  if (reference_a.reference_year === null) {
    return 1;
  }

  if (reference_b.reference_year === null) {
    return -1;
  }

  if (reference_a.reference_year < reference_b.reference_year) {
    return 11;
  }

  if (reference_a.reference_year > reference_b.reference_year) {
    return -1;
  }

  return 0
}

function classifyReferencePopulations(scored_populations) {
  let matched_populations = [];
  let unmatched_populations = [];
  for (let reference_data of scored_populations) {
    if (reference_data.match_cancer_type) {
      matched_populations.push(reference_data);
    } else {
      unmatched_populations.push(reference_data);
    }
  }

  return {matched_populations, unmatched_populations};
}
